import React from 'react';
import { Lightbulb, Clock, Settings, Check, XCircle } from 'lucide-react';

/**
 * Status configuration for feedback items
 * 0: Eingereicht (Submitted)
 * 1: Wird berücksichtigt (Being considered)
 * 2: Wird umgesetzt (Being implemented)
 * 3: Erledigt (Completed)
 */
const statusConfig = {
    0: {
        label: 'Eingereicht',
        icon: Lightbulb,
        color: '#f59e0b', // amber/warning
        bgColor: 'rgba(245, 158, 11, 0.1)',
    },
    1: {
        label: 'Wird berücksichtigt',
        icon: Clock,
        color: '#3b82f6', // blue/info
        bgColor: 'rgba(59, 130, 246, 0.1)',
    },
    2: {
        label: 'Wird umgesetzt',
        icon: Settings,
        color: '#8b5cf6', // purple/primary
        bgColor: 'rgba(139, 92, 246, 0.1)',
    },
    3: {
        label: 'Erledigt',
        icon: Check,
        color: '#10b981', // green/success
        bgColor: 'rgba(16, 185, 129, 0.1)',
    },
    4: {
        label: 'Abgelehnt',
        icon: XCircle,
        color: '#ef4444', // red/danger
        bgColor: 'rgba(239, 68, 68, 0.1)',
    },
};

const FeedbackStatusBadge = ({ status, showLabel = true, size = 'default' }) => {
    const config = statusConfig[status] || statusConfig[0];
    const Icon = config.icon;

    const iconSize = size === 'small' ? 14 : size === 'large' ? 20 : 16;
    const fontSize = size === 'small' ? '0.75rem' : size === 'large' ? '0.9rem' : '0.8rem';
    const padding = size === 'small' ? '2px 6px' : size === 'large' ? '6px 12px' : '4px 8px';

    return (
        <span
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '4px',
                padding: padding,
                borderRadius: '6px',
                backgroundColor: config.bgColor,
                color: config.color,
                fontSize: fontSize,
                fontWeight: 500,
                whiteSpace: 'nowrap',
            }}
            title={config.label}
        >
            <Icon size={iconSize} />
            {showLabel && <span>{config.label}</span>}
        </span>
    );
};

export { statusConfig };
export default FeedbackStatusBadge;
